import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as Auth from 'auth/components';

import { login } from 'auth/actions';
import { addInlineMessage, clearInlineMessages, clearGrowlMessages } from 'messages/actions';

import { getIsLoading } from 'auth/selectors';

import { valueFromEvent } from 'lib/util';

class LoginContainer extends PureComponent {
  static propTypes = {
    isLoading: PropTypes.bool.isRequired,
    login: PropTypes.func.isRequired,
    addInlineMessage: PropTypes.func.isRequired,
    clearInlineMessages: PropTypes.func.isRequired,
  };

  state = {
    values: { email: '', password: '' },
    isValid: false,
    isSubmitted: false,
  };

  componentWillMount = () => {
    this.props.clearInlineMessages();
    this.props.clearGrowlMessages();
  };

  handleValueChange = (e) => {
    this.setState({ values: { ...this.state.values, ...valueFromEvent(e) } });
  };

  handleSubmit = ({ isValid }, data) => {
    this.props.clearInlineMessages();
    this.setState({ isSubmitted: true }, () => {
      if (isValid) {
        this.props
          .login(this.state.values.email, this.state.values.password)
          .then((result) => {
            const next = this.props.location.search.split('?next=').pop();
            this.props.history.push(next ? next : '/');
          })
          .catch((err) => this.props.addInlineMessage(err.message, 'danger'));
      } else {
        this.props.addInlineMessage('error.verify', 'danger');
      }
    });
  };

  handleValidation = (isValid) => {
    if (isValid) {
      this.props.clearInlineMessages();
    }
    this.setState({ isValid });
  };

  render = () => (
    <Auth.LoginView
      handleSubmit={this.handleSubmit}
      handleValidation={this.handleValidation}
      handleValueChange={this.handleValueChange}
      isLoading={this.props.isLoading}
      isSubmitted={this.state.isSubmitted}
      values={this.state.values}
    />
  );
}

const mapStateToProps = (state, ownProps) => ({
  isLoading: getIsLoading(state),
});

const mapDispatchToProps = { login, addInlineMessage, clearInlineMessages, clearGrowlMessages };

export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(LoginContainer);



// WEBPACK FOOTER //
// src/modules/auth/containers/LoginContainer.js